import { init } from '@rematch/core'
import createHistory from 'history/createBrowserHistory'
import { connectRoutes } from 'redux-first-router'
import persistState from 'redux-localstorage'
import reduxSubscriptions from './redux/middleware/reduxSubscriptions'
import * as models from './models'
import routes from './routes.js'

const router = connectRoutes(createHistory(), routes)

const persistor = persistState()

const store = init({
  redux: {
    reducers: {
      location: router.reducer,
    },
    middlewares: [router.middleware, reduxSubscriptions],
    enhancers: [router.enhancer, persistor],
  },
  models,
})

export default store



// WEBPACK FOOTER //
// ./src/store.js